import {showMessage} from 'app/redux/messageSlice'
import {FC, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import ShippingRateList from './ShippingRateList'
import deliveryMethodService from 'app/services/DeliveryMethodService/DeliveryMethodService'
import {
  selectEditOrder,
  selectEditOrderId,
  selectEditOrderItems,
  selectIsShippingAddressSame,
  selectOrderShippingAddress,
  updateEditOrderWithItems,
} from 'app/features/orders/redux/order/orderEditSlice'
import CustomRateButton from '../../../../componentsv1/shared/shippingRate/CustomRateButton'
import {mapShippingOrderModel} from 'app/features/orders/redux/order/helper'
import {Order} from 'app/features/orders/models/EditOrderState'
import Pagination from 'app/components/pagination/PaginationList'

type Props = {
  onShippingRateChange: (val: any) => any
  selectedShippingRate: any
  children: React.ReactNode
  onCustomRateOpen: () => void
}

const pageSize = 5

export const EditShippingRate: FC<Props> = ({
  onShippingRateChange,
  selectedShippingRate,
  children,
  onCustomRateOpen,
}) => {
  const dispatch = useDispatch()
  const orderItems = useSelector<RootState, any[]>(selectEditOrderItems)
  const shippingAddress = useSelector<RootState, any>(selectOrderShippingAddress)
  const orderEditId = useSelector<RootState, string>(selectEditOrderId)
  const order = useSelector<RootState, Order>(selectEditOrder)
  const isShippingAddressSame = useSelector<RootState, boolean>(selectIsShippingAddressSame)
  const [shippingMethods, setShippingMethods] = useState<any[]>([])
  const [isFetching, setIsFetching] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    try {
      const fetch = async () => {
        setIsFetching(true)
        let results: any[] = []
        if (order.shippingAddressId) {
          await dispatch(updateEditOrderWithItems())
          results = await deliveryMethodService.getEditOrderRates(order.orderEditId, isShippingAddressSame)
        } else {
          const model = mapShippingOrderModel(shippingAddress, orderItems)
          results = await deliveryMethodService.fetchRates(model)
        }
        setShippingMethods(results)
        setIsFetching(false)
      }
      fetch()
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({text: 'Error occurred while getting shipping methods', variant: 'error'})
      )
    }
  }, [
    dispatch,
    shippingAddress,
    orderItems,
    orderEditId,
    order.shippingAddressId,
    order.orderEditId,
  ])

  const lastIndex = currentPage * pageSize
  const firstIndex = lastIndex - pageSize

  const handlePageChange = (currentPage: any) => {
    setCurrentPage(currentPage)
  }

  return (
    <>
      {children}
      {!isFetching && shippingMethods.length > 0 ? (
        <>
          {shippingMethods.slice(firstIndex, lastIndex).map((shippingMethod: any) => (
            <ShippingRateList
              shippingMethod={shippingMethod}
              onShippingRateChange={onShippingRateChange}
              selectedShippingMethod={selectedShippingRate?.serviceId}
            />
          ))}
          <Pagination
            totalCount={shippingMethods.length}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            pageSize={pageSize}
            className='mb-5'
          />
        </>
      ) : (
        <div className='d-flex w-100 justify-content-center'>
          <span className='indicator-progress d-block'>
            <span className='spinner-border align-middle ms-5 text-info'></span>
          </span>
        </div>
      )}
      <CustomRateButton onClick={onCustomRateOpen} />
    </>
  )
}
export default EditShippingRate
